import { Flex, Spinner } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { usePortalBusServicingPeriodsQuery } from '~/backup/shared/views/deal-overview/dealOverview.gql.generated';

/**
 * Redirects the legacy cycle-scoped Overview (`/deals/:implementationId/cycles/:cycleId`)
 * to its period (`/periods/:reportingPeriod`), which also covers periods still
 * awaiting a cycle. Resolved against this deal's periods, so another deal's
 * cycle id lands on the deal Overview rather than on a same-dated period here.
 */
export const CycleRedirect = (): React.ReactElement => {
  const { implementationId, cycleId } = useParams<{
    implementationId: string;
    cycleId: string;
  }>();
  const { data, loading } = usePortalBusServicingPeriodsQuery({
    variables: { implementationId: implementationId ?? '' },
    skip: !implementationId,
  });

  if (loading && !data) {
    return (
      <Flex justify="center" align="center" minH="20rem">
        <Spinner />
      </Flex>
    );
  }

  const period = data?.portalBusServicingPeriods.find(
    (p) => p.cycle?.id === cycleId,
  );
  const dealPath = `/deals/${implementationId ?? ''}`;
  return (
    <Navigate
      to={period ? `${dealPath}/periods/${period.reportingPeriod}` : dealPath}
      replace
    />
  );
};
